module.exports = __webpack_public_path__ + "assets/bf50fda48f199c0c160739199115588c.mp3";